import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import moment from "moment";

import { CalendarCustomEventType } from "../../../models/JobZone";

import classes from "./ScheduleInfo.module.scss";
import { PrivateAccess } from "../../../keycloak";
import { UserRoles } from "../../../constants/userRoles";

type ScheduleInfoProps = {
  selectedEvent: CalendarCustomEventType;
  setShowTrackingModal: (state: boolean) => void;
  setShowDeletePopup: (state: boolean) => void;
};

export default function ScheduleInfo({
  selectedEvent,
  setShowTrackingModal,
  setShowDeletePopup,
}: ScheduleInfoProps): JSX.Element {
  return (
    <ul className={classes.eventDetails}>
      <li className={classes.header}>
        <span className={classes.eventName}>{selectedEvent.title}</span>
        <div className={classes.icons}>
          <PrivateAccess
            roles={{
              dcs_client: [UserRoles.SCHEDULE_TRACK],
            }}
          >
            <button
              className={classes.clockBtn}
              onClick={() => setShowTrackingModal(true)}
            >
              <i className="pi pi-clock" />
              Clock
            </button>
          </PrivateAccess>
          <PrivateAccess
            roles={{
              dcs_client: [UserRoles.JOB_UPDATE],
            }}
          >
            <Link to={`${selectedEvent.id}/edit`}>
              <Button
                icon="pi pi-pencil"
                className="p-button-primary mr-2 p-button-sm"
                onClick={() => {}}
              />
            </Link>
          </PrivateAccess>
          <PrivateAccess
            roles={{
              dcs_client: [UserRoles.JOB_DELETE],
            }}
          >
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-sm"
              onClick={() => setShowDeletePopup(true)}
            />
          </PrivateAccess>
        </div>
      </li>
      <li>
        <i className="pi pi-map-marker" />
        {selectedEvent.address}
      </li>
      <li>
        <i className="pi pi-calendar" />
        {moment(selectedEvent.start).format("MM/DD/YY h:mm A")} -{" "}
        {moment(selectedEvent.end).format("MM/DD/YY h:mm A")}
      </li>
      <li>
        <i className="pi pi-user" />
        <span>
          {selectedEvent.superVisor || "-"}
          {selectedEvent.additionalSupervisors > 0 ? (
            <small className={classes.additionalSupervisors}>
              +{selectedEvent.additionalSupervisors} other
              {selectedEvent.additionalSupervisors === 1 ? "" : "s"}
            </small>
          ) : null}
        </span>
      </li>
      <li>
        <i />
        <Link className={classes.viewMore} to={`${selectedEvent.id}/view`}>
          View more
        </Link>
      </li>
    </ul>
  );
}
